import React from 'react';
import '../CSS/DataEngineering.css';

const DataEngineering: React.FC = () => {
  return (
    <div className="data-engineering-page">
      <div className="data_engineering_banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Data Engineering</h1>
        </div>
      </div>

      <div className="data-engin-card">
        <div className="data-engin-content">
          <div className="data-engin-description">
            <p>Our data scientists have extensive experience analyzing, visualizing, and preprocessing complex data sets using manual techniques and automated tools like Pandas and NumPy to ensure they are ready for seamless training of your AI models.</p>
          </div>
          
          <div className="data_engin_cards">
            <div className="data-engin-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Data Engineering/data-gathering-icon.svg" alt="Data Gathering And Preprocessing" />
              </div>
              <h3 className="card-title">Data Gathering And Preprocessing</h3>
              <p className="card-description">Our data scientists collect structured and unstructured data using web scraping and API integration and prepare them by using techniques like feature engineering and data normalization to ensure the data is ready for model training.</p>
            </div>

            <div className="data-engin-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Data Engineering/data-annotation-icon.svg" alt="Data Annotation" />
              </div>
              <h3 className="card-title">Data Annotation</h3>
              <p className="card-description">By labeling and categorizing data using manual techniques and automated tools, our data scientists enable machine learning algorithms to recognize patterns and make accurate predictions.</p>
            </div>

            <div className="data-engin-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Data Engineering/algorythm-icon.svg" alt="Algorithm Selection And Hyperparameter Tuning" />
              </div>
              <h3 className="card-title">Algorithm Selection And Hyperparameter Tuning</h3>
              <p className="card-description">Our data scientists leverage techniques like EDA, experimentation, and hypothesis testing to select the ideal ML algorithm for your project. They also use methods like Grid search and Bayesian optimization for hyperparameter tuning to ensure there are no inefficiencies in the model being developed.</p>
            </div>

            <div className="data-engin-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Data Engineering/model-training-icon.svg" alt="Model Training And Validation" />
              </div>
              <h3 className="card-title">Model Training And Validation</h3>
              <p className="card-description">We use numerous ML techniques like supervised and unsupervised learning and reinforcement learning to train the model and validate it for accuracy using techniques like cross-validation, confusion matrix and ROC curve.</p>
            </div>

            <div className="data-engin-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Data Engineering/model-evaluation-icon.svg" alt="Model Evaluation" />
              </div>
              <h3 className="card-title">Model Evaluation</h3>
              <p className="card-description">Once deployed, our data scientists use evaluation metrics like precision, accuracy, recall and F1 score to resolve any anomalies in the model and analyze its performance to identify underperforming segments and address any issues in them.</p>
            </div>

            <div className="data-engin-card-item">
              <div className="card-icon">
                <img src="/Assets/Services/Data Engineering/outcome-assessment-icon.svg" alt="Outcome Assessment" />
              </div>
              <h3 className="card-title">Outcome Assessment</h3>
              <p className="card-description">Our data scientists can assess your business shortcomings, analyze your data to uncover valuable insights and develop a comprehensive strategy to help you harness the full potential of your data and make well-informed, data-driven decisions for business growth.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="data_engin_image_divider">
        <img src="/Assets/Services/Data Engineering/data-engineering-section-image.png" alt="Data Engineering Section Divider" />
      </div>

      <div className="data_engin_methods">
        <div className="data-engin-methods-content">
          <h2 className="data-engin-methods-title">Methods Used by Our Data Scientists to Extract Insights from Data</h2>
          
          <div className="data-engin-methods-grid">
            <div className="data-engin-method-item">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/machine-learning-icon.svg" alt="Machine Learning Algorithms" />
              </div>
              <div className="method-content">
                <h3 className="method-title">Machine Learning Algorithms</h3>
                <p className="method-description">Our data scientists use multiple ML algorithms, like decision trees, linear regression, logistic regression, random forests, support vector machines, and KNN for classification, regression, clustering, and dimensionality reduction to build AI models.</p>
              </div>
            </div>

            <div className="data-engin-method-item">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/deep-learning-icon.svg" alt="Deep Learning" />
              </div>
              <div className="method-content">
                <h3 className="method-title">Deep Learning</h3>
                <p className="method-description">We utilize numerous deep learning algorithms and techniques like neural networks, CNNs, RNNs and autoencoders to derive valuable insights from datasets and build accurate AI models for diverse use cases.</p>
              </div>
            </div>

            <div className="data-engin-method-item">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/supervised-learning-icon.svg" alt="Supervised Learning" />
              </div>
              <div className="method-content">
                <h3 className="method-title">Supervised Learning</h3>
                <p className="method-description">Our data scientists select, and curate labeled data for training AI models. They choose the appropriate model architecture, define the loss function and optimization algorithm, and tune the model's hyperparameters for optimal performance.</p>
              </div>
            </div>

            <div className="data-engin-method-item">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/unsupervised-learning-icon.svg" alt="Unsupervised Learning" />
              </div>
              <div className="method-content">
                <h3 className="method-title">Unsupervised Learning</h3>
                <p className="method-description">Our data scientists discover patterns and relationships in unlabeled data by choosing appropriate algorithms. They also carefully assess and interpret the unsupervised learning algorithms to draw meaningful conclusions.</p>
              </div>
            </div>

            <div className="data-engin-method-item">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/transfer-learning-icon.svg" alt="Transfer Learning" />
              </div>
              <div className="method-content">
                <h3 className="method-title">Transfer Learning</h3>
                <p className="method-description">We select a pre-trained model that has been trained for a task similar to the one at hand. Our data scientists design and curate the dataset for fine-tuning the model and tuning the model's hyperparameters for optimal performance.</p>
              </div>
            </div>

            <div className="data-engin-method-item">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/reinforcement-learning-icon.svg" alt="Reinforcement Learning" />
              </div>
              <div className="method-content">
                <h3 className="method-title">Reinforcement Learning</h3>
                <p className="method-description">We utilize developer resources and advanced tools like Markov Decision Processes to employ reinforcement learning techniques, which help us train agents to perform tasks to maximize rewards based on environmental feedback.</p>
              </div>
            </div>

            <div className="data-engin-method-item">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/nlp-icon.svg" alt="NLP" />
              </div>
              <div className="method-content">
                <h3 className="method-title">NLP</h3>
                <p className="method-description">Our data scientists utilize multiple NLP toolkits such as NLTK and SpaCy and NLP techniques like tokenization, stemming, and lemmatization to identify the root words in text data and simplify the data by breaking it down into smaller components.</p>
              </div>
            </div>

            <div className="data-engin-method-item">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/computer-vision-icon.svg" alt="Computer Vision" />
              </div>
              <div className="method-content">
                <h3 className="method-title">Computer Vision</h3>
                <p className="method-description">We leverage computer vision to interpret and analyze digital images and videos using numerous tools and techniques, such as feature extraction, image processing techniques, OpenCV, and TensorFlow.</p>
              </div>
            </div>

            <div className="data-engin-method-item full-width">
              <div className="method-icon">
                <img src="/Assets/Services/Data Engineering/ai-technology-stack-icon.svg" alt="AI Technology Stack" />
              </div>
              <div className="method-content">
                <h3 className="method-title">AI Technology Stack</h3>
                <div className="tech-stack-grid">
                  <div className="tech-category">
                    <h4 className="tech-category-title">Cloud Platforms:</h4>
                    <p className="tech-category-content">AWS, Google Cloud Platform, Azure</p>
                  </div>
                  <div className="tech-category">
                    <h4 className="tech-category-title">AI Frameworks:</h4>
                    <p className="tech-category-content">TensorFlow, PyTorch</p>
                  </div>
                  <div className="tech-category">
                    <h4 className="tech-category-title">Integration and Deployment:</h4>
                    <p className="tech-category-content">Docker, Kubernetes, Databricks, Airflow</p>
                  </div>
                  <div className="tech-category">
                    <h4 className="tech-category-title">Programming Language:</h4>
                    <p className="tech-category-content">Python, SQL, Java, JavaScript, TypeScript</p>
                  </div>
                  <div className="tech-category">
                    <h4 className="tech-category-title">Visualization:</h4>
                    <p className="tech-category-content">Tableau, Looker, PowerBI</p>
                  </div>
                  <div className="tech-category">
                    <h4 className="tech-category-title">Collaboration:</h4>
                    <p className="tech-category-content">Git Lab, Jupyter Lab, Jira, Confluence</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataEngineering; 